import * as React from 'react';
import ListItemButton from '@mui/material/ListItemButton';
import ListItemIcon from '@mui/material/ListItemIcon';
import ListItemText from '@mui/material/ListItemText';
import DashboardIcon from '@mui/icons-material/Dashboard';
import ShoppingCartIcon from '@mui/icons-material/ShoppingCart';
import PeopleIcon from '@mui/icons-material/People';
import KitchenIcon from '@mui/icons-material/Kitchen';
import FastfoodIcon from '@mui/icons-material/Fastfood';
import ClassIcon from '@mui/icons-material/Class';
import OutdoorGrillIcon from '@mui/icons-material/OutdoorGrill';
import HowToRegIcon from '@mui/icons-material/HowToReg';
import CardGiftcardIcon from '@mui/icons-material/CardGiftcard';
import DirectionsCarIcon from '@mui/icons-material/DirectionsCar';

export const mainListItems = (
  <React.Fragment>
    <ListItemButton to="/dashboard">
      <ListItemIcon>
        <DashboardIcon />
      </ListItemIcon>
      <ListItemText primary="Dashboard" />
    </ListItemButton>
    <ListItemButton to="/orders">
      <ListItemIcon>
        <ShoppingCartIcon />
      </ListItemIcon>
      <ListItemText primary="Food Orders" />
    </ListItemButton>
    <ListItemButton to="/ordersreport">
      <ListItemIcon>
        <ShoppingCartIcon />
      </ListItemIcon>
      <ListItemText primary="Food Orders Report" />
    </ListItemButton>

    {/* <ListItemButton to="/dailysalesreport">
      <ListItemIcon>
        <ShoppingCartIcon />
      </ListItemIcon>
      <ListItemText primary="Daily Sales Report" />
    </ListItemButton> */}

    <ListItemButton to="/RidersMap">
      <ListItemIcon>
        <ShoppingCartIcon />
      </ListItemIcon>
      <ListItemText primary="Riders Map" />
    </ListItemButton>
    <ListItemButton to="/gift/orders">
      <ListItemIcon>
        <CardGiftcardIcon />
      </ListItemIcon>
      <ListItemText primary="Gift Orders" />
    </ListItemButton>
    <ListItemButton to="/customers">
      <ListItemIcon>
        <PeopleIcon />
      </ListItemIcon>
      <ListItemText primary="Customers" />
    </ListItemButton>
    <ListItemButton to="/chefs">
      <ListItemIcon>
      <OutdoorGrillIcon />
      </ListItemIcon>
      <ListItemText primary="Restaurants" />
    </ListItemButton>
    <ListItemButton>
      <ListItemIcon>
        <KitchenIcon />
      </ListItemIcon>
      <ListItemText primary="Kitchens" />
    </ListItemButton>
    <ListItemButton to="/dishes">
      <ListItemIcon>
        <FastfoodIcon />
      </ListItemIcon>
      <ListItemText primary="Dishes" />
    </ListItemButton>
    <ListItemButton>
      <ListItemIcon>
        <ClassIcon />
      </ListItemIcon>
      <ListItemText primary="Cuisines" />
    </ListItemButton>
    <ListItemButton to="/registrations">
      <ListItemIcon>
        <HowToRegIcon />
      </ListItemIcon>
      <ListItemText primary="Restaurant Forms" />
    </ListItemButton>
    <ListItemButton to="/drivers">
      <ListItemIcon>
        <DirectionsCarIcon />
      </ListItemIcon>
      <ListItemText primary="Driver Forms" />
    </ListItemButton>
    <ListItemButton to="/gifts">
      <ListItemIcon>
        <CardGiftcardIcon />
      </ListItemIcon>
      <ListItemText primary="Gifts/Flowers" />
    </ListItemButton>
    <ListItemButton to="/bookings">
      <ListItemIcon>
        <PeopleIcon />
      </ListItemIcon>
      <ListItemText primary="Iftar Bookings" />
    </ListItemButton>
    <ListItemButton to="/areas">
      <ListItemIcon>
        <DirectionsCarIcon />
      </ListItemIcon>
      <ListItemText primary="Areas" />
    </ListItemButton>
  </React.Fragment>
);
